import TemplateView from "../../../TemplateView";
import ScopeCell, {SCOPE_CELL_STATUS} from "./ScopeCell";
import ManageCellDetailsBlock from "./ManageCellDetailsBlock";

export default class ManageScopeCell extends TemplateView {

    constructor({
        onClickCb = () => {}
    }) {
        super();

        this.params = {
            onClickCb
        }

        this.state = {
            highlighted: false,
            disabled: false,
            readOnly: false,
            status: SCOPE_CELL_STATUS.ALL,
            nCustomers: 0,
            nProjects: 0,
            nTasks: 0,
        }

        this.onAnyStatePropertyChanged(['highlighted', 'disabled', 'status', 'readOnly'], () => {
            this.scopeCell.setState({
                highlighted: this.state.highlighted,
                disabled: this.state.disabled || this.state.readOnly,
                status: this.state.status
            })
        })

        this.onAnyStatePropertyChanged(['status', 'nCustomers', 'nProjects', 'nTasks'], () => {
            this.manageDetailsBlock.setState({
                status: this.state.status,
                nCustomers: this.state.nCustomers,
                nProjects: this.state.nProjects,
                nTasks: this.state.nTasks
            })
        })
    }

    templateHtml() {
        return "<div class='manageScopeCellContainer'></div>"
    }

    afterRender() {
        this.manageDetailsBlock = new ManageCellDetailsBlock();
        this.scopeCell = new ScopeCell({
            onClickCb: this.params.onClickCb,
            detailsBlock: this.manageDetailsBlock,
            notAllowedTextKey: 'user.scope_cell.no_access',
            notSelectedTextKey: 'user.scope_cell.manage_scope.not_selected',
            noAccessTextKey: 'user.scope_cell.manage_scope.no_access'
        }).init(this.$el)
        this.scopeCell.setState({
            allSelectedTextKey: 'user.scope_cell.manage_scope.all_selected'
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/permissions/ManageScopeCell.js